import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { TableModule, Table } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { Scheda } from '../../models/scheda.model';
import { StiliService } from '../../services/stili.service';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TabViewModule } from 'primeng/tabview';
import { Menu } from 'primeng/menu';
import localeIt from '@angular/common/locales/it';
import * as maplibregl from 'maplibre-gl';
import { SchedeService } from '../../services/schede.service';
import { Subscription } from 'rxjs';
import { NuovaSchedaComponent } from './nuova-scheda/nuova-scheda.component';
import {
  SchedaGeoJsonUtils,
  SchedeFeatureCollection,
} from '../../models/scheda-geojson.model';
import { ComuniService } from '../../services/comuni.service';
import { ComuniFeatureCollection } from '../../models/comune-geojson.model';
import { MappaSchedaComponent } from './mappa-scheda/mappa-scheda.component';
import proj4 from 'proj4';
import * as FileSaver from 'file-saver';
import { ExcelService } from '../../services/excelService.service';
import { CodiceATO } from '../../models/codice-ato.model';
import { OggettoIntervento } from '../../models/oggetto-intervento.model';
import { Bacino } from '../../models/bacino.model';
import { Comune } from '../../models/comune.model';
import { Accessibilita } from '../../models/accessibilita.model';
import { BaciniService } from '../../services/bacini.service';
import { CaroselloImmaginiComponent } from './immagini/carosello-immagini.component';
import { FirebaseStorageService } from '../../services/firebase-storage.service';
import { CaricaImmaginiComponent } from './immagini/carica-immagini.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { ModificaSchedaComponent } from './modifica-scheda/modifica-scheda.component';
import { CaricaAllegatoComponent } from './carica-allegato/carica-allegato.component';
import { CaricaGeoJSONComponent } from './carica-geojson/carica-geojson.component';
import { BaciniFeatureCollection } from '../../models/bacino-geojson.model';

export function playerFactory() {
  return player;
}
// Registro il locale italiano
registerLocaleData(localeIt, 'it-IT');

interface ComuneFeature {
  id: string;
  type: string;
  geometry: {
    type: string;
    coordinates: number[][][];
  };
  properties: {
    denominazione: string;
    [key: string]: any;
  };
}

@Component({
  selector: 'app-schede',
  templateUrl: './schede.component.html',
  styleUrls: ['./schede.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    TagModule,
    TooltipModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    TieredMenuModule,
    TabViewModule,
    NuovaSchedaComponent,
    MappaSchedaComponent,
    CaroselloImmaginiComponent,
    CaricaImmaginiComponent,
    ProgressSpinnerModule,
    LottieComponent,
    ModificaSchedaComponent,
    CaricaAllegatoComponent,
    CaricaGeoJSONComponent,
  ],
  providers: [MessageService],
})
export class SchedeComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('map') mapContainer!: ElementRef;

  options: AnimationOptions = {
    path: '/assets/animations/spinner-downloading.json',
    loop: true,
    autoplay: true,
  };

  annoCorrente: number = new Date().getFullYear();
  statoFiltro: string | null = null;
  enteFiltro: string | null = null;
  selectedScheda: Scheda | null = null;

  // Flag per tracciare se i filtri sono attivi
  filtriAttivi: boolean = false;
  richiesteAnnoSuccessivoSonoPresenti: boolean = true;
  isEnteEsecutore: boolean = false;
  enteId: string | null = null;
  titoloSchede: string = 'SCHEDE';
  isUmvsOrAdmin: boolean = false;

  // Tab attivo
  activeTabIndex: number = 0;

  // Dialogo filtri
  mostraFiltri: boolean = false;

  codiciAto: CodiceATO[] = [];
  oggettiIntervento: OggettoIntervento[] = [];
  bacini: Bacino[] = [];
  comuni: Comune[] = [];
  accessibilita: Accessibilita[] = [];

  // Opzioni per il filtro geometria
  opzioniFiltroGeometria: any[] = [
    { label: 'Tutte', value: 'tutte' },
    { label: 'Assente', value: 'senza-geometria' },
  ];
  // Parametri filtri
  filtri = {
    bacino: null as Bacino | null,
    comune: null as Comune | null,
  };

  // Opzioni per i filtri
  anniDisponibili: number[] = Array.from(
    { length: 11 },
    (_, i) => new Date().getFullYear() + 1 - i,
  );

  // Array per le richieste
  schede: Scheda[] = [];
  schedeCaricate: boolean = false;
  numeroSchedeSenzaGeometria: number = 0; // Numero di schede senza geometria

  @ViewChild('menuAzioniTiered', { static: true }) azioniMenuTiered!: Menu;
  @ViewChild('dt') dt!: Table;
  @ViewChild(NuovaSchedaComponent) nuovaSchedaComponent!: NuovaSchedaComponent;
  @ViewChild(CaricaImmaginiComponent)
  caricaImmaginiComponent!: CaricaImmaginiComponent;
  @ViewChild(ModificaSchedaComponent)
  modificaSchedaComponent!: ModificaSchedaComponent;
  @ViewChild(CaricaGeoJSONComponent)
  caricaGeoJSONComponent!: CaricaGeoJSONComponent;

  // Mappa
  private map: maplibregl.Map | null = null;
  private markers: maplibregl.Marker[] = [];
  private subscriptions: Subscription[] = [];
  private labelUpdateHandler?: () => void;

  // Proprietà per il filtro globale della tabella
  filtroTestoGlobale: string = '';
  filtroGeometria: 'tutte' | 'senza-geometria' = 'tutte'; // Filtro per geometria caricata

  public menuAzioniItems!: MenuItem[];

  // Colonne da visualizzare nella tabella
  cols: any[] = [
    { field: 'codice', header: 'Codice', sortable: false, width: '3%' },
    {
      field: 'vecchioCodice',
      header: 'Vecchio Codice',
      sortable: false,
      width: '3%',
    },
    { field: 'bacino', header: 'Bacino', sortable: false, width: '5%' },
    { field: 'comune', header: 'Comune', sortable: false, width: '7%' },

    // { field: 'titolo', header: 'Titolo', sortable: false, width: '13%' },
    {
      field: 'oggettoIntervento',
      header: 'Oggetto Intervento',
      sortable: false,
      width: '3%',
    },
    { field: 'codice ATO', header: 'Codice ATO', sortable: false, width: '2%' },
    {
      field: 'codice Tipologia Intervento',
      header: 'Codice Tipologia Intervento',
      sortable: false,
      width: '3%',
    },

    {
      field: 'accessibilita',
      header: 'Accessibilità',
      sortable: false,
      width: '3%',
    },
    { field: 'frequenza', header: 'Freq.', sortable: false, width: '3%' },
    {
      field: 'annoUltimoIntervento',
      header: 'Ultimo Intervento',
      sortable: false,
      width: '5%',
    },
    {
      field: 'annoProssimoIntervento',
      header: 'Prossimo Intervento',
      sortable: false,
      width: '5%',
    },
    {
      field: 'importoUltimoIntervento',
      header: 'Importo Ultimo Intervento',
      sortable: false,
      width: '5%',
    },
    { field: 'allegati', header: 'Allegati', sortable: false, width: '5%' },
  ];

  // Dati dei confini dei comuni
  private comuniData?: ComuniFeatureCollection;
  private baciniData?: BaciniFeatureCollection;
  private comuniSubscription?: Subscription;

  // Proprietà per la mappa scheda modale
  showMappaScheda: boolean = false;
  selectedFeatureGeoJSON: any = null;
  mappaSchedaTitolo: string = 'Visualizzazione scheda';
  schedaSelezionata: Scheda | null = null;
  // Proprietà per la modale di conferma cancellazione
  showConfermaCancellazione: boolean = false;
  schedaDaEliminare: Scheda | null = null;
  showConfermaApprovazione: boolean = false;
  schedaDaApprovare: Scheda | null = null;

  displayCarosello: boolean = false;
  schedaIdCarosello: number = 0;
  codiceSchedaCarosello: string = '';
  isDownloading: boolean = false;

  showCaricaAllegato: boolean = false;
  schedaCaricaAllegato: Scheda | null = null;
  tipoAllegatoCarica: 'pdf' | 'xls' = 'pdf';

  showCaricaGeoJSON: boolean = false;
  schedaCaricaGeoJSON: Scheda | null = null;

  filtroSchedaAttivo: boolean = false;
  schedaFiltrata: Scheda | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private logger: NGXLogger,
    private messageService: MessageService,
    private schedeService: SchedeService,
    private comuniService: ComuniService,
    public stiliService: StiliService,
    private excelService: ExcelService,
    private baciniService: BaciniService,
    private firebaseStorageService: FirebaseStorageService,
  ) {}

  ngOnInit() {
    // Verifica se l'utente è un ENTE_ESECUTORE
    const ruoloUtente = localStorage.getItem('ruolo');
    this.isEnteEsecutore = ruoloUtente === 'ENTE_ESECUTORE';
    this.isUmvsOrAdmin =
      ruoloUtente === 'UMVS' ||
      ruoloUtente === 'ADMIN' ||
      ruoloUtente === 'SUPERADMIN';

    // Ottieni l'ID dell'ente se l'utente è un ENTE_ESECUTORE
    if (this.isEnteEsecutore) {
      this.enteId = localStorage.getItem('enteId') || '';
      this.titoloSchede =
        'SCHEDE DEL ' + localStorage.getItem('enteLabel')?.toUpperCase();
    }

    // Aggiungi colonna geometriaCaricata solo per UMVS o ADMIN
    if (this.isUmvsOrAdmin) {
      this.cols.push({
        field: 'geometriaCaricata',
        header: 'Geometria',
        sortable: false,
        width: '2%',
      });
    }

    this.caricaSchede();
    this.caricaConfiniComuni();
    this.caricaConfiniBacini();

    if (!this.isEnteEsecutore) {
      this.caricaBacini();
    }
  }

  ngAfterViewInit() {
    // Inizializza la mappa dopo che la vista è caricata
    setTimeout(() => {
      this.initializeMap();
    }, 500);
  }

  private caricaBacini(): void {
    this.baciniService.getBacini().subscribe((bacini) => {
      this.bacini = bacini;
      this.caricaComuni();
      //  // this.logger.info('[NUOVA SCHEDA] Bacini caricati con successo '+ this.bacini.length);
    });
  }

  private caricaCodiciAto(): void {
    this.schedeService.getCodiciAto().subscribe((codiciAto) => {
      this.codiciAto = codiciAto;
      // // this.logger.info('[NUOVA SCHEDA] Bacini caricati con successo '+ this.bacini.length);
    });
  }

  private caricaComuni(): void {
    this.comuniService.get().subscribe((comuni) => {
      this.comuni = comuni; // All'inizio mostriamo tutti i comuni
      //  // this.logger.info('[NUOVA SCHEDA] Comuni caricati con successo '+ this.comuni.length);
    });
  }

  private caricaOggettiIntervento(): void {
    this.schedeService.getOggettiIntervento().subscribe((oggettiIntervento) => {
      this.oggettiIntervento = oggettiIntervento;
      this.logger.info(this.oggettiIntervento);
    });
  }

  private caricaLivelliAccessibilita(): void {
    this.schedeService
      .getLivelliAccessibilita()
      .subscribe((livelliAccessibilita) => {
        this.accessibilita = livelliAccessibilita;
        //    // this.logger.info('[NUOVA SCHEDA] Livelli accessibilita caricati con successo '+ this.accessibilita.length);
      });
  }

  private caricaDatiDiRiferimento(): void {
    // Non inizializziamo la mappa qui, ma solo quando necessario
    this.caricaBacini();
    this.caricaComuni();
    this.caricaOggettiIntervento();
    this.caricaLivelliAccessibilita();
    this.caricaCodiciAto();
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index;

    // Quando si passa alla tab della mappa, assicuriamoci che sia inizializzata
    if (this.activeTabIndex === 1 && !this.map) {
      setTimeout(() => {
        this.initializeMap();
      }, 100);
    }
  }

  private initializeMap(): void {
    // Configurazione della mappa - Valle di Susa (Coordinate approssimative)
    const initialState = {
      lng: 7.2, // Longitudine Valle di Susa
      lat: 45.1381, // Latitudine Valle di Susa (Susa)
      zoom: 10.5, // Livello di zoom per vedere tutta la valle
    };

    if (this.mapContainer && this.mapContainer.nativeElement) {
      try {
        // Configurazione per lo stile della mappa con OpenStreetMap
        this.map = new maplibregl.Map({
          container: this.mapContainer.nativeElement,
          style: {
            version: 8 as 8,
            sources: {
              'osm-tiles': {
                type: 'raster',
                tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
                tileSize: 256,
              },
            },
            layers: [
              {
                id: 'osm-tiles',
                type: 'raster',
                source: 'osm-tiles',
                minzoom: 0,
                maxzoom: 19,
              },
            ],
          },
          center: [initialState.lng, initialState.lat],
          zoom: initialState.zoom,
        });

        // Evento di caricamento completato
        this.map.on('load', () => {
          (this.map as any).addControl(
            new maplibregl.FullscreenControl(),
            'top-right',
          );
          // this.logger.info('[SCHEDE] Mappa BASE caricata con successo - INIZIO CARICAMENTO DELLE GEOMETRIE DELLE SCEHDE');
          this.caricaGeometrieSchede();
        });

        // Gestione degli errori
      } catch (error) {
        this.logger.error(
          "[SCHEDE] Errore durante l'inizializzazione della mappa:",
          error,
        );
      }
    } else {
      this.logger.error('[SCHEDE] Elemento mappa non trovato nel DOM');
    }
  }

  private caricaGeometrieSchede(): void {
    this.schedeService.getGeometrieSchede().subscribe(
      (geometrie) => {
        this.logger.info(
          '[SCHEDE] ' +
            (geometrie.features?.length || 0) +
            ' Geometrie schede recuperate con successo',
        );
        const geometria3360 = geometrie.features.find(
          (feature) => feature.properties.id === 3360,
        );
        try {
          // Configura proj4 per la conversione di coordinate
          proj4.defs(
            'EPSG:32632',
            '+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs',
          );

          // Converti le coordinate in tutte le geometrie
          if (geometrie.features && geometrie.features.length > 0) {
            geometrie.features.forEach((feature) => {
              if (feature.geometry) {
                this.convertCoordinates(feature.geometry);
              }
            });
          }

          // Converti in una FeatureCollection valida
          const geoJsonFeatureCollection =
            SchedaGeoJsonUtils.toFeatureCollection(geometrie);

          // Separa le feature in base al tipo geometriaMarker e al tipo effettivo della geometria
          const pointFeatures: SchedeFeatureCollection = {
            type: 'FeatureCollection',
            features: geoJsonFeatureCollection.features.filter(
              (f) =>
                (f.properties as any).geometriaMarker === 'point' ||
                f.geometry.type === 'Point' ||
                f.geometry.type === 'MultiPoint',
            ),
          };

          const lineFeatures: SchedeFeatureCollection = {
            type: 'FeatureCollection',
            features: geoJsonFeatureCollection.features.filter(
              (f) =>
                (f.properties as any).geometriaMarker === 'linestring' ||
                f.geometry.type === 'LineString' ||
                f.geometry.type === 'MultiLineString',
            ),
          };

          const polygonFeatures: SchedeFeatureCollection = {
            type: 'FeatureCollection',
            features: geoJsonFeatureCollection.features.filter(
              (f) =>
                (f.properties as any).geometriaMarker === 'polygon' ||
                f.geometry.type === 'Polygon' ||
                f.geometry.type === 'MultiPolygon',
            ),
          };

          // Standardizza le geometrie in base al loro tipo
          const standardizedPoints =
            pointFeatures.features.length > 0
              ? SchedaGeoJsonUtils.standardizzaGeometrie(pointFeatures, 'point')
              : null;

          const standardizedLines =
            lineFeatures.features.length > 0
              ? SchedaGeoJsonUtils.standardizzaGeometrie(lineFeatures, 'line')
              : null;

          const standardizedPolygons =
            polygonFeatures.features.length > 0
              ? SchedaGeoJsonUtils.standardizzaGeometrie(
                  polygonFeatures,
                  'polygon',
                )
              : null;

          // Assegna i colori a tutte le geometrie
          [standardizedPoints, standardizedLines, standardizedPolygons]
            .filter((collection) => collection !== null)
            .forEach((collection) => {
              collection!.features.forEach((feature) => {
                (feature.properties as any).color =
                  feature.properties.geometriaColore;
              });
            });

          // Aggiungi le geometrie alla mappa
          if (this.map) {
            // Rimuovi layer e source esistenti
            ['points-source', 'lines-source', 'polygons-source'].forEach(
              (sourceId) => {
                if ((this.map as any).getLayer(sourceId)) {
                  (this.map as any).removeLayer(sourceId);
                }
                if ((this.map as any).getSource(sourceId)) {
                  (this.map as any).removeSource(sourceId);
                }
              },
            );

            // Aggiungi i point layer (marker)
            if (standardizedPoints && standardizedPoints.features.length > 0) {
              // Crea immagini per i marker speciali
              this.creaTriangoloMarker();
              this.creaAsteriskMarker();

              (this.map as any).addSource('points-source', {
                type: 'geojson',
                data: standardizedPoints,
              });

              // Layer per i marker circolari (default)
              (this.map as any).addLayer({
                id: 'points-circle-source',
                type: 'circle',
                source: 'points-source',
                filter: [
                  'all',
                  ['!=', ['get', 'color'], '#33a02c'],
                  ['!=', ['get', 'oggettoInterventoCodice'], 'SG'],
                ],
                paint: {
                  'circle-radius': 6,
                  'circle-color': ['get', 'color'],
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#ffffff',
                },
              });

              // Layer per i marker triangolari (per punti verdi)
              (this.map as any).addLayer({
                id: 'points-triangle-source',
                type: 'symbol',
                source: 'points-source',
                filter: [
                  'all',
                  ['==', ['get', 'color'], '#33a02c'],
                  ['!=', ['get', 'oggettoInterventoCodice'], 'SG'],
                ],
                layout: {
                  'icon-image': 'triangle-marker',
                  'icon-size': 0.7,
                  'icon-allow-overlap': true,
                },
              });

              // Layer per i marker a stella (per oggettoInterventoCodice = SG)
              (this.map as any).addLayer({
                id: 'points-star-source',
                type: 'symbol',
                source: 'points-source',
                filter: ['==', ['get', 'oggettoInterventoCodice'], 'SG'],
                layout: {
                  'icon-image': 'asterisk-marker',
                  'icon-size': 0.7,
                  'icon-allow-overlap': true,
                },
                paint: {
                  'icon-color': ['get', 'color'],
                },
              });
            }

            // Aggiungi i linestring layer
            if (standardizedLines && standardizedLines.features.length > 0) {
              (this.map as any).addSource('lines-source', {
                type: 'geojson',
                data: standardizedLines,
              });

              // Layer per le linestring normali (solide)
              (this.map as any).addLayer({
                id: 'lines-source',
                type: 'line',
                source: 'lines-source',
                filter: [
                  'all',
                  ['!=', ['get', 'oggettoInterventoCodice'], 'AV'],
                  ['!=', ['get', 'oggettoInterventoCodice'], 'AL'],
                ],
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round',
                },
                paint: {
                  'line-color': ['get', 'color'],
                  'line-width': 3,
                  'line-opacity': 1,
                },
              });

              // Layer per le linestring tratteggiate (AV o AL)
              (this.map as any).addLayer({
                id: 'lines-dashed-source',
                type: 'line',
                source: 'lines-source',
                filter: [
                  'any',
                  ['==', ['get', 'oggettoInterventoCodice'], 'AV'],
                  ['==', ['get', 'oggettoInterventoCodice'], 'AL'],
                ],
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round',
                },
                paint: {
                  'line-color': ['get', 'color'],
                  'line-width': 3,
                  'line-opacity': 1,
                  'line-dasharray': [3, 2], // Pattern tratteggiato: 3px linea, 2px spazio
                },
              });
            }

            // Aggiungi i polygon layer
            if (
              standardizedPolygons &&
              standardizedPolygons.features.length > 0
            ) {
              (this.map as any).addSource('polygons-source', {
                type: 'geojson',
                data: standardizedPolygons,
              });

              // Creo un canvas per generare il pattern di linee parallele
              this.creaPatternLineeDiagonali();

              // Aggiungi il contorno dei poligoni
              (this.map as any).addLayer({
                id: 'polygons-outline-source',
                type: 'line',
                source: 'polygons-source',
                paint: {
                  'line-color': ['get', 'color'],
                  'line-width': 2,
                  'line-opacity': 1,
                },
              });

              // Aggiungi il riempimento dei poligoni con pattern a linee
              (this.map as any).addLayer({
                id: 'polygons-source',
                type: 'fill',
                source: 'polygons-source',
                paint: {
                  'fill-color': ['get', 'color'],
                  'fill-opacity': 0.8, // Riduco l'opacità
                  'fill-pattern': 'diagonal-stripes', // Uso il pattern creato
                },
              });
            }

            // Aggiungi interattività ai vari layer
            this.aggiungiInterattivitaGeometrie();

            // Evento di caricamento e aggiunta confini comuni
            this.map.on('sourcedata', (e: any) => {
              const sourceIds = [
                'points-source',
                'lines-source',
                'polygons-source',
              ];
              if (
                sourceIds.includes(e.sourceId) &&
                this.map &&
                (this.map as any).getSource(e.sourceId)
              ) {
                if ((this.map as any).isSourceLoaded(e.sourceId)) {
                  // Dopo che le geometrie delle schede sono caricate, aggiungi i confini dei comuni
                  this.aggiungiConfiniComuni();
                  this.aggiungiConfiniBacini();

                  // Centra la mappa sulle coordinate del comune
                  const longitudine = localStorage.getItem('longitudineComune');
                  const latitudine = localStorage.getItem('latitudineComune');

                  if (longitudine && latitudine && this.isEnteEsecutore) {
                    // Crea un bounds che include tutte le geometrie
                    const bounds = new maplibregl.LngLatBounds();
                    let hasGeometries = false;

                    // Aggiungi tutte le coordinate delle feature al bounds
                    [
                      standardizedPoints,
                      standardizedLines,
                      standardizedPolygons,
                    ]
                      .filter((collection) => collection !== null)
                      .forEach((collection) => {
                        collection!.features.forEach((feature) => {
                          if (feature.geometry.type === 'Point') {
                            bounds.extend(
                              feature.geometry.coordinates as [number, number],
                            );
                            hasGeometries = true;
                          } else if (feature.geometry.type === 'LineString') {
                            feature.geometry.coordinates.forEach(
                              (coord: [number, number]) => {
                                bounds.extend(coord);
                                hasGeometries = true;
                              },
                            );
                          } else if (feature.geometry.type === 'Polygon') {
                            feature.geometry.coordinates[0].forEach(
                              (coord: [number, number]) => {
                                bounds.extend(coord);
                                hasGeometries = true;
                              },
                            );
                          }
                        });
                      });

                    // Se non ci sono geometrie, crea un bounds intorno al comune con un raggio di 5km
                    if (!hasGeometries) {
                      const comuneLng = parseFloat(longitudine);
                      const comuneLat = parseFloat(latitudine);
                      bounds.extend([comuneLng - 0.04, comuneLat - 0.04]);
                      bounds.extend([comuneLng + 0.04, comuneLat + 0.04]);
                    } else {
                      // Aggiungi le coordinate del comune al bounds esistente
                      bounds.extend([
                        parseFloat(longitudine),
                        parseFloat(latitudine),
                      ]);
                    }

                    // Centra la mappa sul bounds con un po' di padding
                    (this.map as any).fitBounds(bounds, {
                      padding: 50,
                      maxZoom: 15,
                      duration: 1000,
                    });
                  } else {
                  }
                }
              }
            });
          } else {
            this.logger.error('[SCHEDE] Mappa non inizializzata');
          }
        } catch (error) {
          this.logger.error(
            '[SCHEDE] Errore nella conversione dei dati GeoJSON:',
            error,
          );
          this.messageService.add({
            severity: 'error',
            summary: 'Errore dati',
            detail:
              "Errore durante l'elaborazione delle geometrie: " +
              (error as Error).message,
            life: 5000,
          });
        }
      },
      (error) => {
        this.logger.error(
          '[SCHEDE] Errore nel recupero delle geometrie delle schede:',
          error,
        );
        this.messageService.add({
          severity: 'error',
          summary: 'Errore di connessione',
          detail: 'Impossibile recuperare le geometrie delle schede',
          life: 5000,
        });
      },
    );
  }

  /**
   * Genera un array di colori casuali in formato esadecimale
   * @param count Numero di colori da generare
   * @returns Array di colori in formato esadecimale (#RRGGBB)
   */
  private generaColoriCasuali(count: number): string[] {
    const colori: string[] = [];

    // Genera colori vivaci ed escludendo grigi e colori troppo chiari/scuri
    const coloriPredefiniti = [
      '#E63946', // Rosso
      '#F4A261', // Arancione
      '#2A9D8F', // Verde acqua
      '#264653', // Blu scuro
      '#F1C40F', // Giallo
      '#8E44AD', // Viola
      '#27AE60', // Verde
      '#3498DB', // Blu
      '#E67E22', // Arancione scuro
      '#C0392B', // Rosso scuro
      '#1ABC9C', // Turchese
      '#9B59B6', // Viola chiaro
    ];

    // Se abbiamo un numero di geometrie minore o uguale ai colori predefiniti
    if (count <= coloriPredefiniti.length) {
      // Mescoliamo l'array dei colori predefiniti
      const shuffled = [...coloriPredefiniti].sort(() => Math.random() - 0.5);
      return shuffled.slice(0, count);
    }

    // Altrimenti, usiamo i colori predefiniti e ne generiamo di nuovi
    colori.push(...coloriPredefiniti);

    // Genera i colori rimanenti in modo casuale
    for (let i = coloriPredefiniti.length; i < count; i++) {
      // Formula per generare colori vivaci:
      const hue = Math.floor(Math.random() * 360); // Tonalità (0-360)
      const saturation = 70 + Math.floor(Math.random() * 30); // Saturazione (70-100%)
      const lightness = 45 + Math.floor(Math.random() * 10); // Luminosità (45-55%)

      // Convertiamo HSL in RGB e poi in formato esadecimale
      const rgb = this.hslToRgb(hue / 360, saturation / 100, lightness / 100);
      const hex =
        '#' +
        rgb[0].toString(16).padStart(2, '0') +
        rgb[1].toString(16).padStart(2, '0') +
        rgb[2].toString(16).padStart(2, '0');

      colori.push(hex);
    }

    return colori;
  }

  /**
   * Converte colore da formato HSL a RGB
   * h, s, l sono in range [0, 1]
   */
  private hslToRgb(h: number, s: number, l: number): [number, number, number] {
    let r, g, b;

    if (s === 0) {
      r = g = b = l; // Scala di grigi
    } else {
      const hue2rgb = (p: number, q: number, t: number) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };

      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  }

  // Metodo per aggiungere un marcatore al centro della mappa come fallback
  private aggiungiMarkereCentrale(): void {
    if (!this.map) return;

    // Aggiungi un marcatore visibile al centro della mappa
    const centerPoint = (this.map as any).getCenter();

    // Crea elemento HTML per il marker
    const el = document.createElement('div');
    el.className = 'marker-debug';
    el.style.width = '25px';
    el.style.height = '25px';
    el.style.borderRadius = '50%';
    el.style.backgroundColor = '#FF0000'; // Rosso per debug
    el.style.cursor = 'pointer';
    el.style.border = '2px solid #FFFFFF';

    // Aggiungi tooltip al marker
    el.title = 'Punto centrale (Debug)';

    // Crea e aggiungi il marker alla mappa
    const marker = new maplibregl.Marker(el)
      .setLngLat([centerPoint.lng, centerPoint.lat])
      .addTo(this.map as any);

    // Aggiungi popup con messaggio di errore
    new maplibregl.Popup({
      closeButton: false,
      closeOnClick: true,
    })
      .setLngLat([centerPoint.lng, centerPoint.lat])
      .setHTML(
        '<h3>Attenzione</h3><p>Impossibile visualizzare le geometrie delle schede</p>',
      )
      .addTo(this.map as any);

    // Aggiungi il marker all'array per la pulizia
    this.markers.push(marker);
  }

  private aggiungiMarker(): void {
    /* if (!this.map) return;

    // Esempio: marker per alcune località nella Valle di Susa
    const puntiInteresse = [
      { nome: 'Susa', lng: 7.0496, lat: 45.1381 },
      { nome: 'Bussoleno', lng: 7.1493, lat: 45.1372 },
      { nome: 'Bardonecchia', lng: 6.6969, lat: 45.0769 }
    ];

    puntiInteresse.forEach(punto => {
      // Crea elemento HTML per il marker
      const el = document.createElement('div');
      el.className = 'marker';
      el.style.width = '25px';
      el.style.height = '25px';
      el.style.borderRadius = '50%';
      el.style.backgroundColor = '#3FB1CE';
      el.style.cursor = 'pointer';
      el.style.border = '2px solid #FFFFFF';

      // Aggiungi tooltip al marker
      el.title = punto.nome;

      // Aggiungi evento click al marker
      el.addEventListener('click', () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Località',
          detail: punto.nome,
          life: 3000
        });
      });

      // Crea e aggiungi il marker alla mappa
      const marker = new maplibregl.Marker(el)
        .setLngLat([punto.lng, punto.lat])
        .addTo(this.map as any);

      // Aggiungi il marker all'array per la pulizia
      this.markers.push(marker);
    }); */
  }

  caricaSchede() {
    this.schedeCaricate = false;
    this.schedeService.getSchede().subscribe((schede) => {
      this.schede = schede;

      if (this.dt) {
        if (this.filtroTestoGlobale) {
          // this.logger.info('[SCHEDE] Filtro testo globale:', this.filtroTestoGlobale);
          this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
        }
        if (this.filtri.bacino) {
          // this.logger.info('[SCHEDE] Filtro bacino:', this.filtri.bacino?.id);
          this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
        }
        if (this.filtri.comune) {
          // this.logger.info('[SCHEDE] Filtro comune:', this.filtri.comune?.id);
          this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
        }
        // Applica filtro geometria se attivo e utente è UMVS/ADMIN
        if (this.isUmvsOrAdmin && this.filtroGeometria === 'senza-geometria') {
          this.dt.filter(false, 'geometriaCaricata', 'equals');
        } else if (this.isUmvsOrAdmin && this.filtroGeometria === 'tutte') {
          // Rimuovi il filtro geometria
          this.dt.filter(null, 'geometriaCaricata', 'equals');
        }
        this.schedeCaricate = true;
      } else {
        this.schedeCaricate = true;
      }

      // Calcola il numero di schede senza geometria in modo asincrono
      setTimeout(() => {
        this.calcolaSchedeSenzaGeometria();
      }, 0);
    });
  }

  /**
   * Gestisce l'evento di filtro della tabella
   */
  onFilterChange(event: any): void {
    // Aggiorna il conteggio delle schede senza geometria solo se non è stato applicato il filtro su geometriaCaricata
    if (!this.isUmvsOrAdmin || this.filtroGeometria !== 'senza-geometria') {
      // Usa setTimeout con un piccolo delay per assicurarsi che i filtri siano stati applicati e filteredValue sia aggiornato
      setTimeout(() => {
        this.calcolaSchedeSenzaGeometria();
      }, 100);
    }
  }

  /**
   * Calcola il numero di schede senza geometria in modo asincrono
   * Usa i dati filtrati dalla tabella se disponibili, altrimenti tutti i dati
   */
  private calcolaSchedeSenzaGeometria(): void {
    // Usa i dati filtrati se disponibili, altrimenti tutti i dati
    const schedeDaAnalizzare =
      this.dt && this.dt.filteredValue
        ? this.dt.filteredValue
        : this.schede || [];

    if (schedeDaAnalizzare && schedeDaAnalizzare.length > 0) {
      this.numeroSchedeSenzaGeometria = schedeDaAnalizzare.filter(
        (scheda: Scheda) => scheda.geometriaCaricata !== true,
      ).length;
      this.logger.info(
        `[SCHEDE] Schede senza geometria: ${this.numeroSchedeSenzaGeometria} su ${schedeDaAnalizzare.length} (filtrate)`,
      );
    } else {
      this.numeroSchedeSenzaGeometria = 0;
    }
  }

  openCaricaAzioni(event: any, scheda: Scheda): Promise<void> {
    this.selectedScheda = scheda;
    this.loadAzioni(event, scheda);
    this.azioniMenuTiered.toggle(event);
    return Promise.resolve();
  }

  scaricaAllegati(scheda: Scheda, tipo: string) {
    this.isDownloading = true;
    this.logger.info(
      `[SCHEDE] Scarica allegati scheda ${scheda.id} - tipo: ${tipo}`,
    );
    if (scheda.vecchioCodiceUmvs && scheda.vecchioCodiceUmvs.length > 0) {
      let fileUrl: string | null = null;
      let fileName: string = '';
      if (tipo === 'pdf') {
        fileUrl = scheda.percorsoPdf || '';
        fileName = scheda.codice + '.pdf';

        // Per i PDF, usiamo lo stesso approccio che funziona per gli XLS
        // Apriamo in una nuova finestra e aggiungiamo un parametro per forzare il download
        window.open(fileUrl + '?download=true', '_blank');
        this.isDownloading = false;
        return;
      } else {
        fileUrl = scheda.percorsoXls || '';
        fileName = scheda.codice + '.xls';

        // Per gli XLS, creiamo un link temporaneo per il download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isDownloading = false;
        return;
      }
    } else {
      if (tipo === 'pdf') {
        const path = `schede/${scheda.codice}/allegati/${scheda.percorsoPdf}`;
        this.firebaseStorageService.downloadFile(path).subscribe({
          next: (blob: Blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${scheda.percorsoPdf}`;
            link.click();
            window.URL.revokeObjectURL(url);
            this.isDownloading = false;
          },
          error: (error: Error) => {
            this.logger.error(
              `[SCHEDE] Errore durante il download del PDF:`,
              error,
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Impossibile scaricare il file PDF',
            });
            this.isDownloading = false;
          },
        });
      } else {
        const path = `schede/${scheda.codice}/allegati/${scheda.percorsoXls}`;
        this.firebaseStorageService.downloadFile(path).subscribe({
          next: (blob: Blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${scheda.percorsoXls}`;
            link.click();
            window.URL.revokeObjectURL(url);
            this.isDownloading = false;
          },
          error: (error: Error) => {
            this.logger.error(
              `[SCHEDE] Errore durante il download dell'Excel:`,
              error,
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Impossibile scaricare il file Excel',
            });
            this.isDownloading = false;
          },
        });
      }
    }
  }
  scaricaReportSchede() {
    const blob = this.excelService.exportSchedeToExcel(
      this.schede,
      'report_schede.xlsx',
      true,
    );
    if (blob) {
      FileSaver.saveAs(blob, 'report_schede.xlsx');
      this.messageService.add({
        severity: 'success',
        summary: 'Download completato',
        detail: 'Il Report delle schede è stato scaricato',
      });
    }
  }
  loadAzioni(event: any, scheda: Scheda) {
    this.menuAzioniItems = [];
    let itemsAllegatiScheda: any[] = [
      {
        label: 'Carica PDF',
        icon: PrimeIcons.FILE_PDF,
        style: { 'font-size': '12px' },
        command: () => this.caricaAllegati(scheda, 'pdf'),
      },
      {
        label: 'Carica Excel',
        icon: PrimeIcons.FILE_EXCEL,
        style: { 'font-size': '12px' },
        command: () => this.caricaAllegati(scheda, 'xls'),
      },
    ];
    let itemsImmaginiScheda: any[] = [
      {
        label: 'Mostra',
        icon: PrimeIcons.EYE,
        style: { 'font-weight': 'bold', 'font-size': '12px' },
        command: () => this.apriImmaginiScheda(scheda),
      },
    ];
    if (!this.isEnteEsecutore) {
      itemsImmaginiScheda.push({
        label: 'Carica',
        icon: PrimeIcons.UPLOAD,
        style: { 'font-weight': 'bold', 'font-size': '12px' },
        command: () => this.caricaImmaginiScheda(scheda),
      });
    }

    // Mostra "Mostra su mappa" solo se la geometria è caricata
    if (scheda.geometriaCaricata === true) {
      this.menuAzioniItems.push({
        label: 'Mostra su mappa',
        icon: PrimeIcons.MAP_MARKER,
        style: { 'font-weight': 'bold', 'font-size': '12px' },
        command: () => this.mostraSchedaSuMappa(scheda),
      });
    }

    this.menuAzioniItems.push({
      label: 'Apri gli interventi',
      icon: PrimeIcons.WRENCH,
      style: { 'font-size': '12px' },
      command: () => this.apriInterventi(scheda),
    });
    if (!this.isEnteEsecutore) {
      this.logger.info(
        '[SCHEDE] Stato approvazione: ' + scheda.statoApprovazione.descrizione,
      );
      if (scheda.statoApprovazione.descrizione === 'In attesa') {
        this.menuAzioniItems.push({
          label: 'Approva',
          icon: PrimeIcons.CHECK,
          style: { 'font-size': '12px' },
          command: () => this.approvaScheda(scheda),
        });
      }
      this.menuAzioniItems.push({
        label: 'Allegati',
        icon: PrimeIcons.PAPERCLIP,
        style: { 'font-size': '12px' },
        items: itemsAllegatiScheda,
      });
    }
    this.menuAzioniItems.push({
      label: 'Immagini',
      icon: PrimeIcons.IMAGES,
      style: { 'font-size': '12px' },
      items: itemsImmaginiScheda,
    });
    if (!this.isEnteEsecutore) {
      this.menuAzioniItems.push(
        {
          label:
            scheda.geometriaCaricata === true
              ? 'Aggiorna geometria'
              : 'Carica geometria',
          icon: PrimeIcons.MAP,
          style: {
            'font-size': '12px',
            'font-weight': 'bold',
          },
          command: () => this.caricaGeoJSON(scheda),
        },
        {
          label: 'Modifica',
          icon: PrimeIcons.PENCIL,
          style: {
            'font-size': '12px',
            'font-weight': 'bold',
          },
          command: () => this.modificaScheda(scheda),
        },
        {
          label: 'Elimina',
          icon: PrimeIcons.ERASER,
          style: {
            'font-size': '12px',
            'font-weight': 'bold',
          },
          command: () => this.eliminaScheda(scheda),
        },
      );
    }
  }

  caricaAllegati(scheda: Scheda, tipo: 'pdf' | 'xls') {
    this.schedaCaricaAllegato = scheda;
    this.tipoAllegatoCarica = tipo;
    this.showCaricaAllegato = true;
  }

  apriImmaginiScheda(scheda: Scheda) {
    this.schedaIdCarosello = scheda.id;
    this.codiceSchedaCarosello = scheda.codice;

    this.displayCarosello = true;
  }

  caricaImmaginiScheda(scheda: Scheda) {
    this.caricaImmaginiComponent.show(scheda);
  }

  modificaScheda(scheda: Scheda) {
    // this.logger.info(`[SCHEDE] Modifica scheda ${scheda.id}`);
    this.modificaSchedaComponent.show(scheda);
  }

  eliminaScheda(scheda: Scheda) {
    this.schedaDaEliminare = scheda;
    this.showConfermaCancellazione = true;
  }

  confermaEliminazione() {
    if (this.schedaDaEliminare) {
      this.schedeService.eliminaScheda(this.schedaDaEliminare.id).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Successo',
            detail: 'Scheda eliminata con successo',
          });
          this.caricaSchede();
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: "Errore durante l'eliminazione della scheda",
          });
          this.logger.error(
            "[SCHEDE] Errore durante l'eliminazione della scheda",
            error,
          );
        },
      });
    }
    this.showConfermaCancellazione = false;
    this.schedaDaEliminare = null;
  }

  nuovaScheda() {
    // this.logger.info('[SCHEDE] Creazione nuova scheda');
    this.nuovaSchedaComponent.show();
  }

  apriInterventi(scheda: Scheda) {
    // this.logger.info(`[SCHEDE] Apri interventi scheda ${scheda.id}`);
    this.router.navigate(['/interventi'], {
      queryParams: { scheda: scheda.id, codice: scheda.codice },
    });
  }

  approvaScheda(scheda: Scheda) {
    this.schedaDaApprovare = scheda;
    this.showConfermaApprovazione = true;
  }

  confermaApprovazione() {
    if (this.schedaDaApprovare) {
      this.schedeService.approva(this.schedaDaApprovare.id).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Approvazione scheda',
            detail: 'Scheda approvata con successo',
          });
          this.caricaSchede();
        },
        error: (error: Error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: "Errore durante l'approvazione della scheda",
          });
          this.logger.error(
            "[SCHEDE] Errore durante l'approvazione della scheda",
            error,
          );
        },
      });
    }
    this.showConfermaApprovazione = false;
    this.schedaDaApprovare = null;
  }

  mostraSchedaSuMappa(scheda: Scheda) {
    // this.logger.info(`[SCHEDE] Mostra scheda su mappa scheda ${scheda.id}`);
    this.schedaSelezionata = scheda;
    this.logger.info(`[SCHEDE] Mostra scheda su mappa scheda ${scheda.id}`);
    // Ottieni i dati GeoJSON di tutte le schede e filtra per ID
    this.schedeService.getGeometriaSingolaScheda(scheda.id).subscribe(
      (geometrie: SchedeFeatureCollection) => {
        // Filtra la feature corrispondente alla scheda selezionata
        const schedaFeature = geometrie.features.find(
          (feature) =>
            feature.properties && feature.properties.id === scheda.id,
        );

        if (schedaFeature) {
          // Crea una feature collection con solo questa scheda
          this.selectedFeatureGeoJSON = {
            type: 'FeatureCollection',
            features: [schedaFeature],
          };
          this.mappaSchedaTitolo = `Posizione della scheda `;
          // Apri il modale della mappa
          this.showMappaScheda = true;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Nessuna geometria trovata per questa scheda',
            life: 5000,
          });
        }
      },
      (error: Error) => {
        this.logger.error(
          `[SCHEDE] Errore nel recupero delle geometrie delle schede`,
          error,
        );
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile recuperare le geometrie delle schede',
          life: 5000,
        });
      },
    );
  }

  scaricaRichieste() {
    // this.logger.info('[SCHEDE] Avvio download richieste');
    this.messageService.add({
      severity: 'info',
      summary: 'Download avviato',
      detail: 'Il download delle richieste è stato avviato',
      life: 3000,
    });
  }

  apriFiltri(): void {
    this.mostraFiltri = true;
  }

  onFiltroGeometriaChange(): void {
    if (this.dt) {
      if (this.filtroGeometria === 'senza-geometria') {
        // Mostra solo schede senza geometria
        this.dt.filter(false, 'geometriaCaricata', 'equals');
      } else {
        // Mostra tutte le schede (rimuovi filtro)
        this.dt.filter(null, 'geometriaCaricata', 'equals');
      }
      // Aggiorna il flag dei filtri attivi
      this.verificaFiltriAttivi();
    }
  }

  verificaFiltriAttivi(): void {
    this.filtriAttivi =
      this.filtri.bacino !== null ||
      this.filtri.comune !== null ||
      (this.isUmvsOrAdmin && this.filtroGeometria === 'senza-geometria') ||
      this.isEnteEsecutore;
  }

  applicaFiltri(): void {
    this.mostraFiltri = false;
    // Verifica se sono stati applicati filtri
    this.verificaFiltriAttivi();
    this.statoFiltro =
      this.filtri.bacino?.denominazione ||
      this.filtri.comune?.denominazione ||
      '';

    if (this.dt) {
      if (this.filtri.bacino) {
        this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
      } else if (this.filtri.comune) {
        this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
      }
      // Applica filtro geometria se attivo e utente è UMVS/ADMIN
      if (this.isUmvsOrAdmin) {
        if (this.filtroGeometria === 'senza-geometria') {
          this.dt.filter(false, 'geometriaCaricata', 'equals');
        } else {
          this.dt.filter(null, 'geometriaCaricata', 'equals');
        }
      }
    }

    // Applica i filtri anche sulla mappa
    if (this.map) {
      const layerIds = [
        'points-circle-source',
        'points-triangle-source',
        'points-star-source',
        'lines-source',
        'lines-dashed-source',
        'polygons-source',
        'polygons-outline-source',
      ];

      // Crea il filtro per la mappa
      let mapFilter: any[] = ['all'];

      if (this.filtri.bacino) {
        mapFilter.push(['==', ['get', 'bacinoId'], this.filtri.bacino.id]);
      }
      if (this.filtri.comune) {
        mapFilter.push(['==', ['get', 'comuneId'], this.filtri.comune.id]);
      }

      // Applica il filtro a tutti i layer
      layerIds.forEach((layerId) => {
        if ((this.map as any).getLayer(layerId)) {
          (this.map as any).setFilter(
            layerId,
            mapFilter.length > 1 ? mapFilter : null,
          );
        }
      });

      // Se ci sono filtri attivi, zoomma sulle geometrie filtrate
      if (this.filtriAttivi) {
        setTimeout(() => {
          const bounds = new maplibregl.LngLatBounds();
          let hasValidCoordinates = false;

          // Recupera tutte le feature filtrate
          layerIds.forEach((layerId) => {
            if ((this.map as any).getLayer(layerId)) {
              const features = (this.map as any).queryRenderedFeatures(null, {
                layers: [layerId],
              });

              features.forEach((feature: maplibregl.MapGeoJSONFeature) => {
                try {
                  if (
                    feature.geometry.type === 'Point' &&
                    Array.isArray(feature.geometry.coordinates)
                  ) {
                    const [lng, lat] = feature.geometry.coordinates;
                    if (this.isValidCoordinate(lng, lat)) {
                      bounds.extend([lng, lat]);
                      hasValidCoordinates = true;
                    }
                  } else if (
                    feature.geometry.type === 'LineString' &&
                    Array.isArray(feature.geometry.coordinates)
                  ) {
                    feature.geometry.coordinates.forEach((coord: number[]) => {
                      const [lng, lat] = coord;
                      if (this.isValidCoordinate(lng, lat)) {
                        bounds.extend([lng, lat]);
                        hasValidCoordinates = true;
                      }
                    });
                  } else if (
                    feature.geometry.type === 'Polygon' &&
                    Array.isArray(feature.geometry.coordinates)
                  ) {
                    feature.geometry.coordinates[0].forEach(
                      (coord: number[]) => {
                        const [lng, lat] = coord;
                        if (this.isValidCoordinate(lng, lat)) {
                          bounds.extend([lng, lat]);
                          hasValidCoordinates = true;
                        }
                      },
                    );
                  }
                } catch (error) {
                  this.logger.error(
                    "[SCHEDE] Errore nell'elaborazione delle coordinate:",
                    error,
                  );
                }
              });
            }
          });

          // Se abbiamo coordinate valide, applica lo zoom
          if (hasValidCoordinates) {
            try {
              this.logger.info(
                '[SCHEDE] Applico zoom su bounds:',
                bounds.toString(),
              );
              (this.map as any).fitBounds(bounds, {
                padding: 20,
                maxZoom: 15,
                duration: 2000,
              });
            } catch (error) {
              this.logger.error(
                "[SCHEDE] Errore nell'applicazione dello zoom:",
                error,
              );
            }
          }
        }, 100);
      }
    }
  }

  resetFiltri(): void {
    this.filtri = {
      bacino: null,
      comune: null,
    };
  }

  azzeraTuttiFiltri(): void {
    this.resetFiltri();
    this.filtroGeometria = 'tutte'; // Reset filtro geometria
    this.filtriAttivi = false;
    this.filtroSchedaAttivo = false;
    this.schedaFiltrata = null;
    this.statoFiltro = null;
    this.dt.reset();
    this.filtraGeometrieMappa('');

    // Aggiorna il conteggio delle schede senza geometria dopo il reset
    setTimeout(() => {
      this.calcolaSchedeSenzaGeometria();
    }, 0);

    // Ripristina lo zoom e la centratura iniziale
    if (this.map) {
      (this.map as any).setCenter([7.2, 45.1381]); // Coordinate iniziali della Valle di Susa
      (this.map as any).setZoom(10.5); // Livello di zoom iniziale
    }
  }

  pulisciFiltroGlobale() {
    this.filtroTestoGlobale = '';
    if (this.dt) {
      this.dt.filterGlobal('', 'contains');
      // Il conteggio verrà aggiornato tramite l'evento onFilter della tabella
    }
    // Ripristina la visualizzazione di tutte le geometrie sulla mappa
    this.filtraGeometrieMappa('');

    // Ripristina lo zoom e la centratura iniziale
    if (this.map) {
      (this.map as any).setCenter([7.2, 45.1381]); // Coordinate iniziali della Valle di Susa
      (this.map as any).setZoom(10.5); // Livello di zoom iniziale
    }
  }

  onFiltroGlobaleChange(event: Event) {
    if (this.dt) {
      // Casting esplicito di event.target a HTMLInputElement per accedere a value
      const inputValue = (event.target as HTMLInputElement).value;
      this.filtroTestoGlobale = inputValue;
      this.dt.filterGlobal(inputValue, 'contains');
      // Il conteggio verrà aggiornato tramite l'evento onFilter della tabella

      // Applica il filtro anche alle geometrie sulla mappa
      if (this.map) {
        const layerIds = [
          'points-circle-source',
          'points-triangle-source',
          'points-star-source',
          'lines-source',
          'lines-dashed-source',
          'polygons-source',
          'polygons-outline-source',
        ];

        // Applica i filtri a tutti i layer
        layerIds.forEach((layerId) => {
          if ((this.map as any).getLayer(layerId)) {
            // Se il testo di ricerca è vuoto, mostra tutte le geometrie
            if (!inputValue) {
              (this.map as any).setFilter(layerId, null);
              return;
            }

            // Crea un filtro che cerca il testo in modo case-insensitive
            const filter = [
              'any',
              [
                'all',
                ['has', 'codice'],
                [
                  '==',
                  ['downcase', ['get', 'codice']],
                  inputValue.toLowerCase(),
                ],
              ],
              [
                'all',
                ['has', 'vecchioCodiceUmvs'],
                [
                  '==',
                  ['downcase', ['get', 'vecchioCodiceUmvs']],
                  inputValue.toLowerCase(),
                ],
              ],
            ];

            // Applica il filtro al layer
            (this.map as any).setFilter(layerId, filter);
          }
        });

        // Rimuovi eventuali listener precedenti
        (this.map as any).off('render');

        // Aggiungi un listener per l'evento render
        (this.map as any).once('render', () => {
          // Recupera tutte le feature filtrate
          const geometrieFiltrate: any[] = [];

          // Recupera le feature da ogni source
          const sourceIds = [
            'points-source',
            'lines-source',
            'polygons-source',
          ];
          sourceIds.forEach((sourceId) => {
            const source = (this.map as any).getSource(sourceId);
            if (source) {
              try {
                // Usa querySourceFeatures invece di queryRenderedFeatures
                const features = (this.map as any).querySourceFeatures(
                  sourceId,
                );

                if (features && features.length > 0) {
                  // Filtra ulteriormente le feature in base al codice di ricerca
                  const filteredFeatures = features.filter((feature: any) => {
                    const codice = feature.properties.codice?.toLowerCase();
                    const vecchioCodiceUmvs =
                      feature.properties.vecchioCodiceUmvs?.toLowerCase();
                    const searchTextLower = inputValue.toLowerCase();
                    return (
                      codice === searchTextLower ||
                      vecchioCodiceUmvs === searchTextLower
                    );
                  });

                  if (filteredFeatures.length > 0) {
                    geometrieFiltrate.push(...filteredFeatures);
                  }
                }
              } catch (error) {
                this.logger.error(
                  '[SCHEDE] Errore nel recupero delle feature dal source',
                  sourceId,
                  ':',
                  error,
                );
              }
            }
          });

          // Se ci sono geometrie filtrate, crea un bounds e zoomma su di esse
          if (geometrieFiltrate.length > 0) {
            const bounds = new maplibregl.LngLatBounds();
            let hasValidCoordinates = false;

            geometrieFiltrate.forEach((feature) => {
              try {
                if (
                  feature.geometry.type === 'Point' &&
                  Array.isArray(feature.geometry.coordinates)
                ) {
                  const [lng, lat] = feature.geometry.coordinates;
                  if (this.isValidCoordinate(lng, lat)) {
                    bounds.extend([lng, lat]);
                    hasValidCoordinates = true;
                  }
                } else if (
                  feature.geometry.type === 'LineString' &&
                  Array.isArray(feature.geometry.coordinates)
                ) {
                  feature.geometry.coordinates.forEach((coord: number[]) => {
                    const [lng, lat] = coord;
                    if (this.isValidCoordinate(lng, lat)) {
                      bounds.extend([lng, lat]);
                      hasValidCoordinates = true;
                    }
                  });
                } else if (
                  feature.geometry.type === 'Polygon' &&
                  Array.isArray(feature.geometry.coordinates)
                ) {
                  feature.geometry.coordinates[0].forEach((coord: number[]) => {
                    const [lng, lat] = coord;
                    if (this.isValidCoordinate(lng, lat)) {
                      bounds.extend([lng, lat]);
                      hasValidCoordinates = true;
                    }
                  });
                }
              } catch (error) {
                this.logger.error(
                  "[SCHEDE] Errore nell'elaborazione delle coordinate:",
                  error,
                );
              }
            });

            // Se abbiamo coordinate valide, applica lo zoom
            if (hasValidCoordinates) {
              try {
                (this.map as any).fitBounds(bounds, {
                  padding: 20,
                  maxZoom: 15,
                  duration: 2000,
                });
              } catch (error) {
                this.logger.error(
                  "[SCHEDE] Errore nell'applicazione dello zoom:",
                  error,
                );
              }
            }
          }

          // Riapplica l'interattività ai layer
          this.aggiungiInterattivitaGeometrie();
        });

        // Forza un re-render della mappa
        (this.map as any).triggerRepaint();
      }
    }
  }

  /**
   * Filtra le geometrie sulla mappa in base al testo di ricerca
   * @param searchText Testo di ricerca
   */
  private filtraGeometrieMappa(searchText: string): void {
    if (!this.map) return;

    // Layer IDs da filtrare
    const layerIds = [
      'points-circle-source',
      'points-triangle-source',
      'points-star-source',
      'lines-source',
      'lines-dashed-source',
      'polygons-source',
      'polygons-outline-source',
    ];

    // Array per tenere traccia delle geometrie filtrate
    const geometrieFiltrate: any[] = [];

    // Applica i filtri a tutti i layer
    layerIds.forEach((layerId) => {
      if ((this.map as any).getLayer(layerId)) {
        // Crea un array di filtri
        let filters: any[] = ['all'];

        // Aggiungi il filtro per il testo di ricerca se presente
        if (searchText) {
          filters.push([
            'any',
            [
              'all',
              ['has', 'codice'],
              ['==', ['downcase', ['get', 'codice']], searchText.toLowerCase()],
            ],
            [
              'all',
              ['has', 'vecchioCodice'],
              [
                '==',
                ['downcase', ['get', 'vecchioCodice']],
                searchText.toLowerCase(),
              ],
            ],
          ]);
        }

        // Aggiungi i filtri per bacino e comune se presenti
        if (this.filtri.bacino) {
          filters.push(['==', ['get', 'bacinoId'], this.filtri.bacino.id]);
        }
        if (this.filtri.comune) {
          filters.push(['==', ['get', 'comuneId'], this.filtri.comune.id]);
        }

        // Applica il filtro al layer
        (this.map as any).setFilter(
          layerId,
          filters.length > 1 ? filters : null,
        );
      }
    });

    // Aspetta che il filtro sia applicato prima di recuperare le feature
    setTimeout(() => {
      // Recupera tutte le feature filtrate
      layerIds.forEach((layerId) => {
        if ((this.map as any).getLayer(layerId)) {
          const features = (this.map as any).queryRenderedFeatures(null, {
            layers: [layerId],
          });

          if (features && features.length > 0) {
            // Se c'è un testo di ricerca, filtra ulteriormente le feature
            if (searchText) {
              const filteredFeatures = features.filter(
                (feature: maplibregl.MapGeoJSONFeature) => {
                  const codice = feature.properties['codice']?.toLowerCase();
                  const vecchioCodice =
                    feature.properties['vecchioCodice']?.toLowerCase();
                  const searchTextLower = searchText.toLowerCase();
                  return (
                    codice === searchTextLower ||
                    vecchioCodice === searchTextLower
                  );
                },
              );
              geometrieFiltrate.push(...filteredFeatures);
            } else {
              geometrieFiltrate.push(...features);
            }
          }
        }
      });

      // Log delle geometrie filtrate
      this.logger.info(
        '[SCHEDE] Geometrie filtrate:',
        geometrieFiltrate.map((f) => ({
          id: f.properties.id,
          codice: f.properties.codice,
          vecchioCodice: f.properties.vecchioCodice,
          tipo: f.geometry.type,
        })),
      );

      // Se ci sono geometrie filtrate, crea un bounds e zoomma su di esse
      if (geometrieFiltrate.length > 0) {
        const bounds = new maplibregl.LngLatBounds();
        let hasValidCoordinates = false;

        geometrieFiltrate.forEach((feature) => {
          try {
            if (
              feature.geometry.type === 'Point' &&
              Array.isArray(feature.geometry.coordinates)
            ) {
              const [lng, lat] = feature.geometry.coordinates;
              if (this.isValidCoordinate(lng, lat)) {
                bounds.extend([lng, lat]);
                hasValidCoordinates = true;
              }
            } else if (
              feature.geometry.type === 'LineString' &&
              Array.isArray(feature.geometry.coordinates)
            ) {
              feature.geometry.coordinates.forEach((coord: number[]) => {
                const [lng, lat] = coord;
                if (this.isValidCoordinate(lng, lat)) {
                  bounds.extend([lng, lat]);
                  hasValidCoordinates = true;
                }
              });
            } else if (
              feature.geometry.type === 'Polygon' &&
              Array.isArray(feature.geometry.coordinates)
            ) {
              feature.geometry.coordinates[0].forEach((coord: number[]) => {
                const [lng, lat] = coord;
                if (this.isValidCoordinate(lng, lat)) {
                  bounds.extend([lng, lat]);
                  hasValidCoordinates = true;
                }
              });
            }
          } catch (error) {
            this.logger.error(
              "[SCHEDE] Errore nell'elaborazione delle coordinate:",
              error,
            );
          }
        });

        // Se abbiamo coordinate valide, applica lo zoom
        if (hasValidCoordinates) {
          try {
            this.logger.info(
              '[SCHEDE] Applico zoom su bounds:',
              bounds.toString(),
            );
            (this.map as any).fitBounds(bounds, {
              padding: 20,
              maxZoom: 15,
              duration: 2000,
            });
          } catch (error) {
            this.logger.error(
              "[SCHEDE] Errore nell'applicazione dello zoom:",
              error,
            );
          }
        }
      }

      // Riapplica l'interattività ai layer
      this.aggiungiInterattivitaGeometrie();
    }, 100);
  }

  private aggiungiInterattivitaGeometrie(): void {
    if (!this.map) return;
    const tooltipEl = document.createElement('div');
    tooltipEl.className = 'maplibre-tooltip';
    tooltipEl.style.display = 'none';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.backgroundColor = 'white';
    tooltipEl.style.padding = '6px 10px';
    tooltipEl.style.borderRadius = '4px';
    tooltipEl.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
    tooltipEl.style.fontSize = '12px';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.zIndex = '1000';
    tooltipEl.innerHTML = 'Tooltip';

    const mapContainer = (this.map as any).getContainer();
    mapContainer.appendChild(tooltipEl);
    const layerIds = [
      'points-circle-source',
      'points-triangle-source',
      'points-star-source',
      'lines-source',
      'lines-dashed-source',
      'polygons-source',
      'polygons-outline-source',
    ];

    // Rimuovi eventi esistenti
    layerIds.forEach((layerId) => {
      if ((this.map as any).getLayer(layerId)) {
        (this.map as any).off('mouseenter', layerId);
        (this.map as any).off('mouseleave', layerId);
        (this.map as any).off('click', layerId);
      }
    });

    // Aggiungi eventi per ogni layer
    layerIds.forEach((layerId) => {
      if ((this.map as any).getLayer(layerId)) {
        (this.map as any).on('mousemove', layerId, (e: any) => {
          if (!this.map || !e.features || e.features.length === 0) return;

          // Imposta il cursore a pointer
          (this.map as any).getCanvas().style.cursor = 'pointer';
          // Estrai informazioni dalla feature
          const feature = e.features[0];

          const titolo = feature.properties.titolo || 'Scheda senza titolo';
          const codice = feature.properties.codice || '';
          const color = feature.properties.color || '#000000';
          const bacinoNome = feature.properties.bacinoNome || '';
          const oggettoInterventoNome =
            feature.properties.oggettoInterventoCodice || '';
          const comuneNome = feature.properties.comuneNome || '';
          // Aggiorna il contenuto del tooltip con i due codici affiancati
          const vecchioCodice = feature.properties.vecchioCodiceUmvs || '';

          const tooltipContent = `
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              ${
                vecchioCodice
                  ? `
                <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #8f5cb7; min-width: 60px;">
                  <span style="color: #8B4513; font-weight: bold; font-size: 11px;">${vecchioCodice}</span>
                </div>
              `
                  : ''
              }
              <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #4285F4; min-width: 60px;">
                <span style="color: #3a6e75; font-weight: bold; font-size: 11px;">${codice}</span>
              </div>
            </div>
          `;

          tooltipEl.innerHTML = tooltipContent;

          // Posiziona il tooltip vicino al cursore
          tooltipEl.style.left = `${e.point.x + 10}px`;
          tooltipEl.style.top = `${e.point.y - 20}px`;

          // Mostra il tooltip
          tooltipEl.style.display = 'block';
        });

        // Cambia il cursore al passaggio del mouse
        (this.map as any).on('mouseenter', layerId, () => {
          (this.map as any).getCanvas().style.cursor = 'pointer';
        });

        // Nascondi il tooltip quando il mouse esce dalla geometria
        (this.map as any).on('mouseleave', layerId, () => {
          if (!this.map) return;

          // Ripristina il cursore
          (this.map as any).getCanvas().style.cursor = '';

          // Nascondi il tooltip
          tooltipEl.style.display = 'none';
        });

        (this.map as any).on('click', layerId, (e: any) => {
          if (!this.map || !e.features || e.features.length === 0) return;

          // Estrai informazioni dalla feature
          const feature = e.features[0];
          const titolo = feature.properties.titolo || 'Scheda senza titolo';
          const codice = feature.properties.codice || '';
          const codiceATO = feature.properties.codiceAto || '';
          const color = feature.properties.color || '#000000';
          const bacinoNome = feature.properties.bacinoNome || '';
          const oggettoInterventoNome =
            feature.properties.oggettoInterventoCodice || '';
          const comuneNome = feature.properties.comuneNome || '';
          // Ottieni le coordinate del click
          const coordinates = e.lngLat;

          // Crea popup con informazioni e codici affiancati
          const vecchioCodice = feature.properties.vecchioCodiceUmvs || '';

          const popupContent = `
            <div class="popup-content">
              <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                ${
                  vecchioCodice
                    ? `
                  <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #8f5cb7; min-width: 60px;">
                    <span style="color: #8B4513; font-weight: bold; font-size: 12px;">${vecchioCodice}</span>
                  </div>
                `
                    : ''
                }
                <div style="display: flex; align-items: center; background: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; border-left: 3px solid #4285F4; min-width: 60px;">
                  <span style="color: #3a6e75; font-weight: bold; font-size: 12px;">${codice}</span>
                </div>
              </div>
              <div style="padding: 10px;">
                ${feature.properties.bacinoNome ? `<p style="margin: 5px 0 0 0; font-size: 13px;"><strong>Bacino:</strong> <span style="color: ${color}">${feature.properties.bacinoNome}</span></p>` : ''}
                ${feature.properties.comuneNome ? `<p style="margin: 5px 0 0 0; font-size: 13px;"><strong>Comune:</strong> <span style="color: ${color}">${feature.properties.comuneNome}</span></p>` : ''}
                <p style="margin: 5px 0 0 0; font-size: 13px;"><strong>Tipo:</strong> <span style="color: ${color}">${oggettoInterventoNome}</span></p>`;

          const popup = new maplibregl.Popup({
            closeButton: true,
            closeOnClick: false,
            maxWidth: '280px',
            className: 'custom-popup',
          })
            .setLngLat(coordinates)
            .setHTML(
              popupContent +
                `

                <div style="margin-top: 15px; text-align: right;">
                  <button onclick="window.dispatchEvent(new CustomEvent('apriDettagliScheda', {detail: ${JSON.stringify(feature.properties).replace(/"/g, '&quot;')}}))"
                          style="background-color: ${color}; color: white; border: none; padding: 5px 10px;
                                 border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: bold;">
                    Apri dettagli
                  </button>
                </div>
              </div>
            </div>
          `,
            )
            .addTo(this.map as any);

          // Aggiungi l'event listener per l'evento personalizzato
          window.addEventListener('apriDettagliScheda', ((e: CustomEvent) => {
            this.logger.info('Evento apriDettagliScheda ricevuto', e.detail);
            this.apriDettagliScheda(e.detail);
          }) as EventListener);
        });
      }
    });
  }

  /**
   * Apre i dettagli di una scheda
   * @param properties Proprietà della scheda
   */
  private apriDettagliScheda(properties: any): void {
    // Ottieni l'ID della scheda
    const schedaId = properties.id;

    // Trova la scheda completa usando l'ID
    const scheda = this.schede.find((s) => s.id === schedaId);

    if (scheda) {
      // Se abbiamo trovato la scheda, filtriamo la tabella
      if (this.dt) {
        // Resetta eventuali filtri precedenti
        this.dt.reset();
        // Applica il filtro per l'ID della scheda
        this.dt.filter(schedaId, 'id', 'equals');

        // Imposta il flag e la scheda filtrata
        this.filtroSchedaAttivo = true;
        this.schedaFiltrata = scheda;

        // Cambia il tab attivo al panel 0 (tabella)
        this.activeTabIndex = 0;
        // Il conteggio verrà aggiornato tramite l'evento onFilter della tabella

        // Mostra un messaggio di conferma
      }
    } else {
      // Se non troviamo la scheda, mostra un messaggio di errore
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: `Impossibile trovare i dettagli della scheda ${schedaId}`,
        life: 3000,
      });
    }
  }

  onSchedaModificata(schedaModificata: Scheda) {
    // this.logger.info('[SCHEDE] Scheda modificata:', schedaModificata);
    this.messageService.add({
      severity: 'success',
      summary: 'Scheda modificata',
      detail: `La scheda ${schedaModificata?.codice ?? ''} è stata modificata con successo`,
      life: 3000,
    });
    this.caricaSchede();
  }

  /**
   * Verifica se le coordinate sono valide
   * @param lng Longitudine
   * @param lat Latitudine
   * @returns true se le coordinate sono valide
   */
  private isValidCoordinate(lng: number, lat: number): boolean {
    return (
      typeof lng === 'number' &&
      typeof lat === 'number' &&
      !isNaN(lng) &&
      !isNaN(lat) &&
      lng >= -180 &&
      lng <= 180 &&
      lat >= -90 &&
      lat <= 90
    );
  }

  onSchedaCreata(nuovaScheda: Scheda) {
    /* this.messageService.add({
      severity: 'success',
      summary: 'Creazione scheda',
      detail: 'La scheda è stata creata con successo',
      life: 3000
    }); */
    this.caricaSchede();
  }

  rimuoviFiltroScheda(): void {
    if (this.dt) {
      this.dt.reset();
      this.filtroSchedaAttivo = false;
      this.schedaFiltrata = null;

      // Se c'erano altri filtri attivi, riapplicarli
      if (this.filtri.bacino) {
        this.dt.filter(this.filtri.bacino?.id, 'bacino.id', 'equals');
      }
      if (this.filtri.comune) {
        this.dt.filter(this.filtri.comune?.id, 'comune.id', 'equals');
      }
      if (this.filtroTestoGlobale) {
        this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
      }
      // Il conteggio verrà aggiornato tramite l'evento onFilter della tabella
    }
  }

  /**
   * Converte le coordinate da UTM a WGS84 (lon/lat) che MapLibre può visualizzare
   * @param geometry La geometria GeoJSON da convertire
   */
  private convertCoordinates(geometry: any): void {
    if (!geometry || !geometry.type) return;

    // Per Point
    if (geometry.type === 'Point' && Array.isArray(geometry.coordinates)) {
      geometry.coordinates = this.transformToWGS84(geometry.coordinates);
    }

    // Per LineString e MultiPoint
    else if (
      (geometry.type === 'LineString' || geometry.type === 'MultiPoint') &&
      Array.isArray(geometry.coordinates)
    ) {
      geometry.coordinates = geometry.coordinates.map((coord: number[]) =>
        this.transformToWGS84(coord),
      );
    }

    // Per Polygon e MultiLineString
    else if (
      (geometry.type === 'Polygon' || geometry.type === 'MultiLineString') &&
      Array.isArray(geometry.coordinates)
    ) {
      geometry.coordinates = geometry.coordinates.map((line: number[][]) =>
        line.map((coord: number[]) => this.transformToWGS84(coord)),
      );
    }

    // Per MultiPolygon
    else if (
      geometry.type === 'MultiPolygon' &&
      Array.isArray(geometry.coordinates)
    ) {
      geometry.coordinates = geometry.coordinates.map((polygon: number[][][]) =>
        polygon.map((line: number[][]) =>
          line.map((coord: number[]) => this.transformToWGS84(coord)),
        ),
      );
    }

    // Per GeometryCollection
    else if (
      geometry.type === 'GeometryCollection' &&
      Array.isArray(geometry.geometries)
    ) {
      geometry.geometries.forEach((geom: any) => this.convertCoordinates(geom));
    }
  }

  /**
   * Trasforma una singola coordinata da UTM a WGS84
   * @param coord Coordinata [x, y] in UTM
   * @returns Coordinata [lon, lat] in WGS84
   */
  private transformToWGS84(coord: number[]): number[] {
    if (!coord || coord.length < 2) return coord;

    try {
      const wgs84Coord = proj4('EPSG:32632', 'EPSG:4326', [coord[0], coord[1]]);
      return wgs84Coord;
    } catch (error) {
      console.error('Errore durante la conversione delle coordinate:', error);
      return coord;
    }
  }

  /**
   * Crea un pattern di linee diagonali parallele e lo aggiunge alla mappa
   */
  private creaPatternLineeDiagonali(): void {
    if (!this.map) return;

    const size = 10;
    const lineWidth = 1;
    const spacing = 4;

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, size, size);
    ctx.fillStyle = 'rgba(0, 0, 0, 0)';
    ctx.fillRect(0, 0, size, size);
    ctx.strokeStyle = 'rgba(128, 128, 128, 0.5)';
    ctx.lineWidth = lineWidth;

    for (let i = -size; i < size * 2; i += spacing) {
      ctx.beginPath();
      ctx.moveTo(i, 0);
      ctx.lineTo(i + size, size);
      ctx.stroke();
    }

    const imageData = canvas.toDataURL();
    const img = new Image();
    img.onload = () => {
      (this.map as any).addImage('diagonal-stripes', img, { sdf: false });
    };
    img.src = imageData;
  }

  /**
   * Crea un'immagine a forma di triangolo da utilizzare come marker
   */
  private creaTriangoloMarker(): void {
    if (!this.map) return;

    const size = 24;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, size, size);
    ctx.beginPath();
    ctx.moveTo(size / 2, 0);
    ctx.lineTo(size, size);
    ctx.lineTo(0, size);
    ctx.closePath();
    ctx.fillStyle = '#33a02c';
    ctx.fill();
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 2;
    ctx.stroke();

    const imageData = canvas.toDataURL();
    const img = new Image();
    img.onload = () => {
      (this.map as any).addImage('triangle-marker', img, { sdf: false });
    };
    img.src = imageData;
  }

  /**
   * Crea un'immagine a forma di asterisco da utilizzare come marker
   */
  private creaAsteriskMarker(): void {
    if (!this.map) return;

    const size = 24;
    const centerX = size / 2;
    const centerY = size / 2;
    const radius = size / 2 - 2;

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, size, size);
    ctx.lineWidth = 3;
    ctx.strokeStyle = 'white';

    const angles = 6;
    for (let i = 0; i < angles; i++) {
      const angle = (Math.PI / angles) * i;
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.lineTo(
        centerX + radius * Math.cos(angle),
        centerY + radius * Math.sin(angle),
      );
      ctx.stroke();
    }

    ctx.beginPath();
    ctx.arc(centerX, centerY, 2, 0, Math.PI * 2);
    ctx.fillStyle = 'white';
    ctx.fill();

    const imageData = canvas.toDataURL();
    const img = new Image();
    img.onload = () => {
      (this.map as any).addImage('asterisk-marker', img, { sdf: true });
    };
    img.src = imageData;
  }

  onAllegatoCaricato(scheda: Scheda | null) {
    this.messageService.add({
      severity: 'success',
      summary: 'Caricamento allegato',
      detail: `L'allegato è stato caricato con successo`,
      life: 3000,
    });
    this.caricaSchede();
  }

  ngOnDestroy() {
    // Cleanup delle sottoscrizioni
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.comuniSubscription) {
      this.comuniSubscription.unsubscribe();
    }

    // Cleanup dei marker
    this.markers.forEach((marker) => marker.remove());

    // Rimuovi listener delle etichette
    if (this.map && this.labelUpdateHandler) {
      (this.map as any).off('moveend', this.labelUpdateHandler);
      (this.map as any).off('zoomend', this.labelUpdateHandler);
      this.labelUpdateHandler = undefined;
    }

    // Cleanup della mappa
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  /**
   * Calcola l'area approssimativa di una feature per prioritizzare etichette più grandi
   */
  private calcolaAreaApprossimativa(feature: any): number {
    if (!feature.geometry) return 0;

    let totalArea = 0;

    if (feature.geometry.type === 'Polygon') {
      totalArea = this.calcolaAreaPoligono(feature.geometry.coordinates[0]);
    } else if (feature.geometry.type === 'MultiPolygon') {
      feature.geometry.coordinates.forEach((polygon: number[][][]) => {
        totalArea += this.calcolaAreaPoligono(polygon[0]);
      });
    }

    return totalArea;
  }

  private calcolaDistanza(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ): number {
    try {
      const R = 6371; // Raggio della Terra in km
      const dLat = ((lat2 - lat1) * Math.PI) / 180;
      const dLon = ((lon2 - lon1) * Math.PI) / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
          Math.cos((lat2 * Math.PI) / 180) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    } catch (error) {
      console.error('[SCHEDE] Errore nel calcolo della distanza:', error);
      return Infinity;
    }
  }

  caricaGeoJSON(scheda: Scheda) {
    this.schedaCaricaGeoJSON = scheda;
    this.showCaricaGeoJSON = true;
  }
  private aggiungiConfiniBacini(): void {
    // this.logger.info('[SCHEDE] AggiungiConfiniBacini');
    if (!this.map || !this.baciniData) return;

    try {
      // Verifica se la source esiste già
      if (!(this.map as any).getSource('bacini-source')) {
        // Aggiungi la fonte dei dati GeoJSON alla mappa
        (this.map as any).addSource('bacini-source', {
          type: 'geojson',
          data: this.baciniData,
        });
        console.log('bacini-source', this.baciniData);
        // Aggiungi il layer per i confini dei bacini (solo se non esiste già)
        if (!(this.map as any).getLayer('bacini-confini')) {
          // Determina il primo layer delle geometrie per posizionare i confini sotto
          let beforeId: string | undefined;
          if ((this.map as any).getLayer('points-circle-source')) {
            beforeId = 'points-circle-source';
          } else if ((this.map as any).getLayer('lines-source')) {
            beforeId = 'lines-source';
          } else if ((this.map as any).getLayer('polygons-source')) {
            beforeId = 'polygons-source';
          }

          const layerConfig: any = {
            id: 'bacini-confini',
            type: 'line',
            source: 'bacini-source',
            layout: {},
            paint: {
              'line-color': '#0000FF', // Blu ben visibile
              'line-width': 2.5, // Spessore linea
              'line-opacity': 1, // Opacità
            },
          };

          // Se esiste un layer delle geometrie, posiziona i confini prima di esso
          if (beforeId) {
            (this.map as any).addLayer(layerConfig, beforeId);
          } else {
            (this.map as any).addLayer(layerConfig);
          }
        } else {
          // Se il layer esiste già, spostalo sotto i layer delle geometrie
          let beforeId: string | undefined;
          if ((this.map as any).getLayer('points-circle-source')) {
            beforeId = 'points-circle-source';
          } else if ((this.map as any).getLayer('lines-source')) {
            beforeId = 'lines-source';
          } else if ((this.map as any).getLayer('polygons-source')) {
            beforeId = 'polygons-source';
          }
          if (beforeId) {
            (this.map as any).moveLayer('bacini-confini', beforeId);
          }
        }
      }
      // Aggiungi le etichette usando HTML markers (calcola il centro di ogni poligono)
      this.aggiungiEtichetteBacini();
    } catch (err) {
      this.logger.error(
        "[SCHEDE] Errore nell'aggiunta dei confini dei bacini",
        err,
      );
    }
  }
  private aggiungiConfiniComuni(): void {
    //this.logger.info('[SCHEDE] AggiungiConfiniComuni');
    if (!this.map || !this.comuniData) return;

    try {
      // Verifica se la source esiste già
      if (!(this.map as any).getSource('comuni-source')) {
        // Aggiungi la fonte dei dati GeoJSON alla mappa
        (this.map as any).addSource('comuni-source', {
          type: 'geojson',
          data: this.comuniData,
        });
        //console.log('comuni-source', this.comuniData);
      }

      // Aggiungi il layer per i confini dei comuni (solo se non esiste già)
      if (!(this.map as any).getLayer('comuni-confini')) {
        // Determina il primo layer delle geometrie per posizionare i confini sotto
        let beforeId: string | undefined;
        if ((this.map as any).getLayer('points-circle-source')) {
          beforeId = 'points-circle-source';
        } else if ((this.map as any).getLayer('lines-source')) {
          beforeId = 'lines-source';
        } else if ((this.map as any).getLayer('polygons-source')) {
          beforeId = 'polygons-source';
        }

        const layerConfig: any = {
          id: 'comuni-confini',
          type: 'line',
          source: 'comuni-source',
          layout: {},
          paint: {
            'line-color': '#FF0000', // Rosso ben visibile
            'line-width': 2.5, // Spessore linea
            'line-opacity': 1, // Opacità
          },
        };

        // Se esiste un layer delle geometrie, posiziona i confini prima di esso
        if (beforeId) {
          (this.map as any).addLayer(layerConfig, beforeId);
        } else {
          (this.map as any).addLayer(layerConfig);
        }
      } else {
        // Se il layer esiste già, spostalo sotto i layer delle geometrie
        let beforeId: string | undefined;
        if ((this.map as any).getLayer('points-circle-source')) {
          beforeId = 'points-circle-source';
        } else if ((this.map as any).getLayer('lines-source')) {
          beforeId = 'lines-source';
        } else if ((this.map as any).getLayer('polygons-source')) {
          beforeId = 'polygons-source';
        }
        if (beforeId) {
          (this.map as any).moveLayer('comuni-confini', beforeId);
        }
      }

      // Aggiungi le etichette usando HTML markers (calcola il centro di ogni poligono)
      this.aggiungiEtichetteComuni();
    } catch (err) {
      this.logger.error(
        "[SCHEDE] Errore nell'aggiunta dei confini comuni",
        err,
      );
    }
  }

  private aggiungiEtichetteBacini(): void {
    if (!this.map || !this.baciniData || !this.baciniData.features) return;

    // Rimuovi solo i markers delle etichette dei bacini esistenti (se ce ne sono)
    const labelMarkers = this.markers.filter(
      (m: any) => (m as any)._labelMarkerBacino,
    );
    labelMarkers.forEach((marker) => {
      marker.remove();
      const index = this.markers.indexOf(marker);
      if (index > -1) {
        this.markers.splice(index, 1);
      }
    });

    // Calcola il centro di ogni poligono e aggiungi un marker con la denominazione
    this.baciniData.features.forEach((feature: any) => {
      if (!feature.properties || !feature.properties.ambito) return;
      if (!feature.geometry || !feature.geometry.coordinates) return;

      let center: [number, number] | null = null;

      // Calcola il centroide geometrico del poligono
      if (feature.geometry.type === 'Polygon') {
        center = this.calcolaCentroide(feature.geometry.coordinates[0]);
      } else if (feature.geometry.type === 'MultiPolygon') {
        // Per MultiPolygon, prendi il centroide del primo poligono (quello più grande)
        let largestPolygon = feature.geometry.coordinates[0][0];
        let largestArea = 0;

        // Trova il poligono più grande
        feature.geometry.coordinates.forEach((polygon: number[][][]) => {
          const area = this.calcolaAreaPoligono(polygon[0]);
          if (area > largestArea) {
            largestArea = area;
            largestPolygon = polygon[0];
          }
        });

        center = this.calcolaCentroide(largestPolygon);
      }

      if (center) {
        // Crea un elemento HTML per l'etichetta
        const el = document.createElement('div');
        el.className = 'bacino-label';
        el.textContent = feature.properties.ambito;
        el.style.cssText = `
          background-color: transparent;
          color: #0000FF;
          padding: 4px 8px;
          font-size: 13px;
          font-weight: bold;
          white-space: nowrap;
          text-shadow: -1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF;
          pointer-events: none;
          user-select: none;
        `;

        // Crea il marker
        const marker = new maplibregl.Marker({
          element: el,
          anchor: 'center',
        })
          .setLngLat(center)
          .addTo(this.map as any);

        // Marca come label marker dei bacini per poterlo rimuovere in seguito
        (marker as any)._labelMarkerBacino = true;
        (marker as any)._feature = feature; // Salva la feature per ricalcolare la posizione
        (marker as any)._element = el; // Salva l'elemento per gestire la visibilità
        this.markers.push(marker);
      }
    });

    // Aggiungi listener per ricalcolare le posizioni in base allo zoom
    this.setupLabelUpdateListener();
    this.aggiornaPosizioniEtichetteBacini();
  }

  private aggiungiEtichetteComuni(): void {
    if (!this.map || !this.comuniData || !this.comuniData.features) return;

    // Rimuovi solo i markers delle etichette dei comuni esistenti (se ce ne sono)
    const labelMarkers = this.markers.filter(
      (m: any) => (m as any)._labelMarkerComune,
    );
    labelMarkers.forEach((marker) => {
      marker.remove();
      const index = this.markers.indexOf(marker);
      if (index > -1) {
        this.markers.splice(index, 1);
      }
    });

    // Calcola il centro di ogni poligono e aggiungi un marker con la denominazione
    this.comuniData.features.forEach((feature: any) => {
      if (!feature.properties || !feature.properties.denominazione) return;
      if (!feature.geometry || !feature.geometry.coordinates) return;

      let center: [number, number] | null = null;

      // Calcola il centroide geometrico del poligono
      if (feature.geometry.type === 'Polygon') {
        center = this.calcolaCentroide(feature.geometry.coordinates[0]);
      } else if (feature.geometry.type === 'MultiPolygon') {
        // Per MultiPolygon, prendi il centroide del primo poligono (quello più grande)
        let largestPolygon = feature.geometry.coordinates[0][0];
        let largestArea = 0;

        // Trova il poligono più grande
        feature.geometry.coordinates.forEach((polygon: number[][][]) => {
          const area = this.calcolaAreaPoligono(polygon[0]);
          if (area > largestArea) {
            largestArea = area;
            largestPolygon = polygon[0];
          }
        });

        center = this.calcolaCentroide(largestPolygon);
      }

      if (center) {
        // Crea un elemento HTML per l'etichetta
        const el = document.createElement('div');
        el.className = 'comune-label';
        el.textContent = feature.properties.denominazione;
        el.style.cssText = `
          background-color: transparent;
          color: #FF0000;
          padding: 4px 8px;
          font-size: 13px;
          font-weight: bold;
          white-space: nowrap;
          text-shadow: -1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF;
          pointer-events: none;
          user-select: none;
        `;

        // Crea il marker
        const marker = new maplibregl.Marker({
          element: el,
          anchor: 'center',
        })
          .setLngLat(center)
          .addTo(this.map as any);

        // Marca come label marker dei comuni per poterlo rimuovere in seguito
        (marker as any)._labelMarkerComune = true;
        (marker as any)._feature = feature; // Salva la feature per ricalcolare la posizione
        (marker as any)._element = el; // Salva l'elemento per gestire la visibilità
        this.markers.push(marker);
      }
    });

    // Aggiungi listener per ricalcolare le posizioni in base allo zoom
    this.setupLabelUpdateListener();
    this.aggiornaPosizioniEtichetteComuni();
  }

  /**
   * Calcola il centroide del poligono visibile nel viewport corrente
   * Filtra le coordinate che sono visibili nel viewport e calcola il centroide
   */
  private calcolaCentroideViewport(feature: any): [number, number] | null {
    if (!this.map || !feature.geometry) return null;

    const bounds = (this.map as any).getBounds();
    const visibleCoords: number[][] = [];

    const processCoordinates = (coords: number[][]) => {
      coords.forEach((coord: number[]) => {
        const [lng, lat] = coord;
        // Controlla se la coordinata è visibile nel viewport
        if (bounds.contains([lng, lat])) {
          visibleCoords.push(coord);
        }
      });
    };

    if (feature.geometry.type === 'Polygon') {
      processCoordinates(feature.geometry.coordinates[0]);
    } else if (feature.geometry.type === 'MultiPolygon') {
      feature.geometry.coordinates.forEach((polygon: number[][][]) => {
        processCoordinates(polygon[0]);
      });
    }

    // Se ci sono coordinate visibili, calcola il centroide di quelle
    if (visibleCoords.length > 0) {
      return this.calcolaCentroide(visibleCoords);
    }

    // Altrimenti calcola il centroide dell'intero poligono
    if (feature.geometry.type === 'Polygon') {
      return this.calcolaCentroide(feature.geometry.coordinates[0]);
    } else if (feature.geometry.type === 'MultiPolygon') {
      let largestPolygon = feature.geometry.coordinates[0][0];
      let largestArea = 0;
      feature.geometry.coordinates.forEach((polygon: number[][][]) => {
        const area = this.calcolaAreaPoligono(polygon[0]);
        if (area > largestArea) {
          largestArea = area;
          largestPolygon = polygon[0];
        }
      });
      return this.calcolaCentroide(largestPolygon);
    }

    return null;
  }

  /**
   * Aggiorna le posizioni delle etichette dei comuni in base al viewport e zoom
   * Gestisce anche la visibilità per evitare sovrapposizioni
   */
  private aggiornaPosizioniEtichetteComuni(): void {
    if (!this.map) return;

    const labelMarkers = this.markers.filter(
      (m: any) => (m as any)._labelMarkerComune,
    );

    // Calcola le posizioni e gestisci le collisioni
    const markersWithPositions: Array<{
      marker: any;
      position: [number, number];
      area: number;
    }> = [];

    labelMarkers.forEach((marker: any) => {
      const feature = (marker as any)._feature;
      if (feature) {
        let newCenter = this.calcolaCentroideViewport(feature);

        // Se non ci sono coordinate visibili, usa il centroide dell'intero poligono
        if (!newCenter) {
          if (feature.geometry.type === 'Polygon') {
            newCenter = this.calcolaCentroide(feature.geometry.coordinates[0]);
          } else if (feature.geometry.type === 'MultiPolygon') {
            let largestPolygon = feature.geometry.coordinates[0][0];
            let largestArea = 0;
            feature.geometry.coordinates.forEach((polygon: number[][][]) => {
              const area = this.calcolaAreaPoligono(polygon[0]);
              if (area > largestArea) {
                largestArea = area;
                largestPolygon = polygon[0];
              }
            });
            newCenter = this.calcolaCentroide(largestPolygon);
          }
        }

        if (newCenter) {
          marker.setLngLat(newCenter);
          // Calcola l'area approssimativa per prioritizzare etichette più grandi
          const area = this.calcolaAreaApprossimativa(feature);
          markersWithPositions.push({ marker, position: newCenter, area });
        }
      }
    });

    // Ordina per area (più grande = più importante)
    markersWithPositions.sort((a, b) => b.area - a.area);

    // Gestisci collisioni: nascondi etichette che si sovrappongono
    const visibleMarkers: any[] = [];
    const minDistance = 0.01; // Distanza minima in gradi (circa 1km)

    markersWithPositions.forEach(({ marker, position, area }) => {
      let hasCollision = false;

      for (const visible of visibleMarkers) {
        // Calcola distanza euclidea in gradi
        const dx = position[0] - visible.position[0];
        const dy = position[1] - visible.position[1];
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Se la distanza è troppo piccola, c'è collisione
        if (distance < minDistance) {
          hasCollision = true;
          break;
        }
      }

      const el = (marker as any)._element || marker.getElement();
      if (el) {
        if (hasCollision) {
          el.style.display = 'none';
        } else {
          el.style.display = 'block';
          visibleMarkers.push({ marker, position, area });
        }
      }
    });
  }

  /**
   * Aggiorna le posizioni delle etichette dei bacini in base al viewport e zoom
   * Gestisce anche la visibilità per evitare sovrapposizioni
   */
  private aggiornaPosizioniEtichetteBacini(): void {
    if (!this.map) return;

    const labelMarkers = this.markers.filter(
      (m: any) => (m as any)._labelMarkerBacino,
    );

    // Calcola le posizioni e gestisci le collisioni
    const markersWithPositions: Array<{
      marker: any;
      position: [number, number];
      area: number;
    }> = [];

    labelMarkers.forEach((marker: any) => {
      const feature = (marker as any)._feature;
      if (feature) {
        let newCenter = this.calcolaCentroideViewport(feature);

        // Se non ci sono coordinate visibili, usa il centroide dell'intero poligono
        if (!newCenter) {
          if (feature.geometry.type === 'Polygon') {
            newCenter = this.calcolaCentroide(feature.geometry.coordinates[0]);
          } else if (feature.geometry.type === 'MultiPolygon') {
            let largestPolygon = feature.geometry.coordinates[0][0];
            let largestArea = 0;
            feature.geometry.coordinates.forEach((polygon: number[][][]) => {
              const area = this.calcolaAreaPoligono(polygon[0]);
              if (area > largestArea) {
                largestArea = area;
                largestPolygon = polygon[0];
              }
            });
            newCenter = this.calcolaCentroide(largestPolygon);
          }
        }

        if (newCenter) {
          marker.setLngLat(newCenter);
          // Calcola l'area approssimativa per prioritizzare etichette più grandi
          const area = this.calcolaAreaApprossimativa(feature);
          markersWithPositions.push({ marker, position: newCenter, area });
        }
      }
    });

    // Ordina per area (più grande = più importante)
    markersWithPositions.sort((a, b) => b.area - a.area);

    // Gestisci collisioni: nascondi etichette che si sovrappongono
    const visibleMarkers: any[] = [];
    const minDistance = 0.01; // Distanza minima in gradi (circa 1km)

    markersWithPositions.forEach(({ marker, position, area }) => {
      let hasCollision = false;

      for (const visible of visibleMarkers) {
        // Calcola distanza euclidea in gradi
        const dx = position[0] - visible.position[0];
        const dy = position[1] - visible.position[1];
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Se la distanza è troppo piccola, c'è collisione
        if (distance < minDistance) {
          hasCollision = true;
          break;
        }
      }

      const el = (marker as any)._element || marker.getElement();
      if (el) {
        if (hasCollision) {
          el.style.display = 'none';
        } else {
          el.style.display = 'block';
          visibleMarkers.push({ marker, position, area });
        }
      }
    });
  }

  /**
   * Configura il listener per aggiornare le posizioni delle etichette quando cambia zoom o viewport
   */
  private setupLabelUpdateListener(): void {
    if (!this.map || this.labelUpdateHandler) return; // Evita di aggiungere listener multipli

    this.labelUpdateHandler = () => {
      this.aggiornaPosizioniEtichetteComuni();
      this.aggiornaPosizioniEtichetteBacini();
    };

    // Aggiorna le posizioni quando cambia lo zoom o la mappa si muove
    this.map.on('moveend', this.labelUpdateHandler);
    this.map.on('zoomend', this.labelUpdateHandler);
  }

  /**
   * Calcola il centroide geometrico di un poligono
   * Usa la formula del centroide che tiene conto dell'area
   */
  private calcolaCentroide(coordinates: number[][]): [number, number] | null {
    if (!coordinates || coordinates.length < 3) return null;

    // Rimuovi l'ultimo punto se è uguale al primo (poligono chiuso)
    const coords =
      coordinates.length > 0 &&
      coordinates[0][0] === coordinates[coordinates.length - 1][0] &&
      coordinates[0][1] === coordinates[coordinates.length - 1][1]
        ? coordinates.slice(0, -1)
        : coordinates;

    if (coords.length < 3) return null;

    // Calcola il centroide usando la formula del centroide geometrico
    let sumX = 0;
    let sumY = 0;
    let signedArea = 0;

    for (let i = 0; i < coords.length; i++) {
      const j = (i + 1) % coords.length;
      const xi = coords[i][0];
      const yi = coords[i][1];
      const xj = coords[j][0];
      const yj = coords[j][1];

      const cross = xi * yj - xj * yi;
      signedArea += cross;
      sumX += (xi + xj) * cross;
      sumY += (yi + yj) * cross;
    }

    signedArea *= 0.5;

    if (Math.abs(signedArea) < 1e-10) {
      // Se l'area è troppo piccola, usa la media semplice
      let sumLng = 0;
      let sumLat = 0;
      coords.forEach((coord: number[]) => {
        sumLng += coord[0];
        sumLat += coord[1];
      });
      return [sumLng / coords.length, sumLat / coords.length];
    }

    return [sumX / (6 * signedArea), sumY / (6 * signedArea)];
  }

  /**
   * Calcola l'area di un poligono usando la formula di Shoelace
   */
  private calcolaAreaPoligono(coordinates: number[][]): number {
    if (!coordinates || coordinates.length < 3) return 0;

    const coords =
      coordinates.length > 0 &&
      coordinates[0][0] === coordinates[coordinates.length - 1][0] &&
      coordinates[0][1] === coordinates[coordinates.length - 1][1]
        ? coordinates.slice(0, -1)
        : coordinates;

    if (coords.length < 3) return 0;

    let area = 0;
    for (let i = 0; i < coords.length; i++) {
      const j = (i + 1) % coords.length;
      area += coords[i][0] * coords[j][1];
      area -= coords[j][0] * coords[i][1];
    }

    return Math.abs(area / 2);
  }

  private caricaConfiniComuni(): void {
    this.comuniService.getConfiniComuni().subscribe(
      (data: ComuniFeatureCollection) => {
        this.comuniData = data;
      },
      (error) => {
        this.logger.error(
          '[SCHEDE] Errore nel recupero dei confini dei comuni:',
          error,
        );
      },
    );
  }

  private caricaConfiniBacini(): void {
    this.baciniService.getConfini().subscribe({
      next: (data: BaciniFeatureCollection) => {
        this.baciniData = data;
        this.aggiungiConfiniBacini();
      },
      error: (error: any) => {
        this.logger.error(
          '[SCHEDE] Errore nel recupero dei confini dei bacini:',
          error,
        );
      },
    });
  }
}
